import React from 'react';

export default function UndoRedoButton({
  onClick,
  disabled,
  icon,
  disabledIcon,
  title,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={title}
      aria-label={title}
      className={`
        inline-flex h-8 w-8 items-center justify-center rounded-full
        border border-md-beige bg-white transition duration-300
        ${
          disabled
            ? 'cursor-not-allowed opacity-70'
            : 'hover:bg-md-beige active:scale-95'
        }
      `}
    >
      <img
        src={disabled ? disabledIcon : icon}
        alt=""
        className="h-3 w-3"
        draggable="false"
      />
    </button>
  );
}
